module.exports = __webpack_public_path__ + "mp.svg?e6ef4c392050cac6e1ebf70a2018d678";